
export enum CustomFieldTypes {
  TEXT = 'text',
  TEXTAREA = 'textarea',
  NUMBER = 'number',
  EMAIL = 'email',
  PHONE = 'phone',
  DROPDOWN = 'dropdown',
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  DATE = 'date',
}

export const CUSTOM_FIELD_TYPE_VALUES = Object.values(CustomFieldTypes);

export enum CustomFormNames {
  CONTACT = 'contact',
  LEAD = 'lead',
  INDIVIDUAL_PROPERTY = 'individual_property',
  TASKS = 'tasks',
  BOOK_OR_HOLD = 'book_or_hold',
  UNIT = 'unit',
}

export const CUSTOM_FORM_NAME_VALUES = Object.values(CustomFormNames);
